import { jsxs as a, jsx as r } from "react/jsx-runtime";
import { useTranslation as m, centsToUnits as p } from "@systemeio/ui";
import { twMerge as o, twJoin as f } from "tailwind-merge";
import { CurrencyBadge as d } from "../../../../../ui-kit/currency-badge.mjs";
import { getAmountWithCurrencySymbol as x } from "../../../../../utils/get-amount-with-currency-symbol.mjs";
import { useLocaleContext as u } from "../../../../../providers/use-locale-provider.mjs";
import { getConditionLabel as g } from "../../utils/get-condition-label.mjs";
import h from "../../../../../ui-kit/icons/success-icon.mjs";
const I = ({
  onChange: s,
  service: c,
  rule: e,
  condition: n,
  isSelected: i
}) => {
  const { t: l } = m(), { locale: t } = u();
  return /* @__PURE__ */ a("label", { className: o("relative flex cursor-pointer items-center gap-2"), children: [
    /* @__PURE__ */ r(
      "input",
      {
        className: o(
          "border-fill-primary h-[20px] w-[20px] rounded-full border-2 outline-hidden",
          i ? "bg-background-secondary" : "bg-transparent",
          "main-transition-colors ring-brand-primary shrink-0 appearance-none ring-offset-1 focus-visible:ring-2"
        ),
        checked: i,
        value: e.id,
        onChange: () => {
          s({
            ruleId: e.id,
            currency: e.currency,
            conditionId: n.id,
            price: n.price
          });
        },
        type: "radio"
      }
    ),
    /* @__PURE__ */ r(h, { className: f(!i && "fill-transparent") }),
    /* @__PURE__ */ r("div", { className: "flex w-full flex-wrap items-center justify-between gap-3", children: /* @__PURE__ */ a(
      "div",
      {
        className: "main-transition-colors flex max-w-full flex-col flex-wrap gap-2 text-left text-[16px] md:max-w-[70%]",
        children: [
          /* @__PURE__ */ a("div", { className: "flex flex-wrap gap-1", children: [
            /* @__PURE__ */ r("span", { className: "flex shrink-0", children: c.name }),
            /* @__PURE__ */ r("span", { className: "flex shrink-0", children: e.name })
          ] }),
          g(n, e, l, t)
        ]
      }
    ) }),
    /* @__PURE__ */ a("div", { className: "ml-auto flex items-center gap-2.5", children: [
      /* @__PURE__ */ r(d, { currency: e.currency }),
      /* @__PURE__ */ r("span", { className: "main-transition-colors text-[14px] font-semibold", children: x(p(n.price), e.currency, t) })
    ] })
  ] });
};
export {
  I as ShippingCondition
};
